import React, { useEffect, useState } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Capacitor } from '@capacitor/core'
import { useTranslation } from 'react-i18next'

import { openModal } from 'store/actions/modals'
import { getHelpLink, intersperse } from 'services/Utilities'
import { TrackAction } from 'services/TrackAction'
import VersionsModal from 'components/Modals/VersionsModal'
import useModal from 'components/Hooks/useModal'

export const Footer = ({ statusClickFunc, realtimeClass, openModal, isInPunch }) => {
  const { t } = useTranslation()

  const [status, setStatus] = useState({ description: '' })
  const [ModalForVersions, openModalForVersions] = useModal()
  // Effect use to refresh the app status
  useEffect(() => {
    queryCurrentStatus()
    // Create a timeout to check for system status every minute
    const statusPageTimeout = setTimeout(queryCurrentStatus, 60000)
    return () => clearTimeout(statusPageTimeout)
  }, [])

  const queryCurrentStatus = async () => {
    try {
      const res = await axios.get('https://status.merinio.com/api/v2/status.json')
      switch (res.data.status.indicator) {
        case 'minor':
          res.data.status.cssClass = 'text-warning'
          break
        case 'major':
        case 'critical':
          res.data.status.cssClass = 'text-danger'
          break
        default:
          res.data.status.cssClass = ''
      }
      setStatus(res.data.status)
    } catch {
      setStatus({ description: 'Could not get status', cssClass: 'text-warning' })
    }
  }
  return (
    <>
      <div className={`mx-auto text-center footer${Capacitor.isNativePlatform() ? '' : ' mb-2'}`}>
        {intersperse(
          [
            <span key="footer_status">
              <span id="footer_realtime" className={realtimeClass}>
                <i className="fa-solid fa-signal-bars mr-1" />
              </span>
              <span id="footer_app_status" className={`cursor-pointer text-underline ${status.cssClass || ''}`} onClick={statusClickFunc}>
                {status.description === 'All Systems Operational' ? <i className="fa-solid fa-shield-check"></i> : status.description}
                <b className="ml-1">{(process.env.REACT_APP_CURRENT_VERSION || 'DEV').slice(0, 7)}</b>
              </span>
            </span>,
            <span key="see_versions" id="see_versions" className="cursor-pointer text-underline" onClick={() => openModalForVersions()}>
              {t('RELEASES')}
            </span>,
            <span
              id="footer_help_center"
              key="footer_help_center"
              className="cursor-pointer text-underline"
              onClick={() => {
                // Track opening help center in intercom
                if (isInPunch) {
                  TrackAction('OPEN_HELP_CENTER', { to: getHelpLink('helpCenter'), from: 'footer' })
                  window.open(getHelpLink('punchTerminal'), '_blank')
                } else {
                  TrackAction('OPEN_HELP_CENTER', { to: getHelpLink('helpCenter'), from: 'footer' })
                  window.open(getHelpLink('helpCenter'), '_blank')
                }
              }}
            >
              {t('HELP_CENTER')}
            </span>,
            <span key="give_feedback" id="give_feedback" className="cursor-pointer text-underline text-primary" onClick={() => openModal('FeedbackModal')}>
              {t('components.feedback.GIVE_FEEDBACK')}
            </span>
          ],
          ' / '
        )}
        <VersionsModal Modal={ModalForVersions} />
      </div>
    </>
  )
}

const mapStateToProps = ({ footer }) => ({
  realtimeClass: footer.realtimeClass
})
const mapDispatchToProps = dispatch => ({ openModal: (...props) => dispatch(openModal(...props)) })

export default connect(mapStateToProps, mapDispatchToProps)(Footer)

// Set the proptypes for validation
Footer.propTypes = {
  statusClickFunc: PropTypes.func
}
Footer.defaultProps = {
  statusClickFunc: () => window.open('https://status.merinio.com', '_blank')
}
